<template>

    <main class="gmp-page gmp-page--no-newsletter">
        <DIS_subpagehero />
        <DIS_two_column_text />
        <DIS_two_column_fullbleed />

    </main>

</template>


<script>
    import DIS_subpagehero from "../../../components/content/market/benefit/DIS_subpagehero";
    import DIS_two_column_text from "../../../components/content/market/benefit/DIS_two_column_text";
    import DIS_two_column_fullbleed from "../../../components/content/market/benefit/DIS_two_column_fullbleed";


    export default {
        name: 'DIS_Benefit',
        components:{
            DIS_subpagehero,
            DIS_two_column_text,
            DIS_two_column_fullbleed,

        }

    }


</script>

<style>



</style>